import { useTranslation } from 'react-i18next';
import { TokenPasswordScreen } from './TokenPasswordScreen';

/**
 * Replaces `Pages/Auth/ActivateAccount.cshtml`.
 *
 * Onboarding: the user sets their first password from the link an administrator
 * had emailed them, which also activates the account and confirms the address.
 * The token comes from a longer-lived provider than the reset one, so the two
 * screens must keep calling their own endpoints — a reset link will not validate
 * here, and that is intended.
 *
 * There is no "request a new link" route: activation mail is only sent by an
 * administrator, so the invalid-link message says to ask one.
 */
export function ActivateAccountPage() {
  const { t } = useTranslation();

  return (
    <TokenPasswordScreen
      validatePath="/api/auth/activate/validate"
      submitPath="/api/auth/activate"
      title={t('auth:Auth.ActivateYourAccount', 'Activate Your Account')}
      subtitle={t(
        'auth:Auth.ActivateAccountMessage',
        'Welcome! Choose a password to activate your account and get started.',
      )}
      invalidSubtitle={t('auth:Auth.ActivationLinkUnusable', 'This activation link can no longer be used.')}
      invalidMessage={t(
        'auth:Auth.ActivationLinkInvalid',
        'This link is invalid or incomplete. Please contact your administrator to receive a new activation email.',
      )}
      newPasswordPlaceholder={t('auth:Auth.EnterPassword', 'Enter a password')}
      confirmPasswordPlaceholder={t('auth:Auth.ReEnterPassword', 'Re-enter your password')}
      submitIcon="check-circle"
      submitLabel={t('auth:Auth.ActivateAccount', 'Activate Account')}
      submitVariant="success"
      pendingLabel={t('auth:Auth.ActivatingAccount', 'Activating account...')}
      successMessage={t('auth:Auth.ActivationSuccess', 'Your account has been activated. You can now log in.')}
    />
  );
}
